import { useNavigate } from 'react-router-dom';
import { PARTNER_CATEGORIES } from '@pomoshnik/shared';
import { Header } from '@/components/Header/Header';
import { BottomBar } from '@/components/BottomBar/BottomBar';
import { VideoButton } from '@/components/VideoButton';

/**
 * Экран 2.9.1 — вход в Блок 9 «Сотрудничество» (заявка поставщика, ADR-0086).
 * Структурно — копия `features/partners/PartnersCategories.tsx`: тот же список
 * категорий (Блок 8 словарь, P-001), layout shell (P-046), VideoButton первым
 * контент-элементом (P-040), вертикальные кнопки (P-019).
 *
 * Отличия от Блока 8:
 *   - Header title «Сотрудничество», без slug-резолва из калькулятора.
 *   - Тап категории → `/cooperation/apply?service=<канон>` (анкета поставщика 2.9.2).
 *   - В КОНЕЦ списка добавлена кнопка «Другое» → `?service=other` (free-text услуга,
 *     PRD 2.9.1 + контракт `customService` ⟺ service==='other').
 *
 * Дизайн-система: bg-canvas/bg-card/text-ink (P-038/P-039), Manrope (P-043),
 * палитра только токенами (P-045). Экран статический (без async) → состояния
 * loading/error не нужны.
 */

/**
 * Видеоинструкция Блока 9 (P-040). Реального YouTube-embed ПОКА НЕТ — Aibek
 * заменит (как PARTNERS/DECOR/HANDLES_VIDEO_URL). Пустая строка → карточка
 * рендерится (P-040 соблюдён), модалка откроет пустой src до получения URL.
 * Открытый вопрос зафиксирован в STOP-отчёте.
 */
export const COOPERATION_VIDEO_URL = '';

export function ServicePicker() {
  const navigate = useNavigate();

  return (
    <main className="min-h-screen flex flex-col bg-canvas">
      <Header title="Сотрудничество" />

      <section className="flex-1 overflow-y-auto flex flex-col gap-3 p-6">
        {/* VideoButton первым контент-элементом (P-040). Заголовок «Сотрудничество» —
            в Header (h1), в контенте не дублируем. */}
        <VideoButton videoUrl={COOPERATION_VIDEO_URL} />

        {/* Категории — вертикальный список (P-019), канон-имена (P-001) */}
        <div className="flex flex-col gap-2">
          {PARTNER_CATEGORIES.map((category) => (
            <button
              key={category}
              type="button"
              onClick={() => navigate(`/cooperation/apply?service=${encodeURIComponent(category)}`)}
              aria-label={category}
              className={
                'min-h-tap w-full rounded-xl bg-card border-[1.5px] border-accent ' +
                'text-ink font-body text-lg font-medium shadow-card ' +
                'flex items-center justify-between gap-3 px-4 py-3 text-left ' +
                'focus-visible:ring-2 focus-visible:ring-cta focus-visible:outline-none active:opacity-90'
              }
            >
              <span className="flex-1">{category}</span>
              <span aria-hidden="true" className="text-ink opacity-40">
                ›
              </span>
            </button>
          ))}

          {/* «Другое» — free-text услуга (service=other → customService в анкете 2.9.2) */}
          <button
            type="button"
            onClick={() => navigate('/cooperation/apply?service=other')}
            aria-label="Другое"
            className={
              'min-h-tap w-full rounded-xl bg-card border-[1.5px] border-accent ' +
              'text-ink font-body text-lg font-medium shadow-card ' +
              'flex items-center justify-between gap-3 px-4 py-3 text-left ' +
              'focus-visible:ring-2 focus-visible:ring-cta focus-visible:outline-none active:opacity-90'
            }
          >
            <span className="flex-1">Другое</span>
            <span aria-hidden="true" className="text-ink opacity-40">
              ›
            </span>
          </button>
        </div>
      </section>

      <BottomBar />
    </main>
  );
}
